import React, { useState } from 'react';
import { IoCloseSharp } from "react-icons/io5";
// import { AxiosInstance } from '../../../../common/Loader/axios.config';
import Swal from 'sweetalert2';
import ClipLoader from 'react-spinners/ClipLoader';
import axios from 'axios';
import { AxiosInstance } from '../../../../common/Loader/axios.config';


export default function CreateProductModal({ isOpen, onClose, project, fetchProducts }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [price, setPrice] = useState('');
    const [thumbnail, setThumbnail] = useState(null);
    const [loading, setLoading] = useState(false);

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('project', project);
        formData.append('title', name);
        formData.append('description', description);
        formData.append('category', category);
        formData.append('price', price);
        if (thumbnail) {
            formData.append('thumbnail', thumbnail);
        }

        console.log("Form Data:")
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        try {
            setLoading(true);
            const response = await AxiosInstance.post('/product', formData);

            console.log("Product Response", response);

            if (response.data.status === "succesful") {
                Swal.fire({
                    icon: "success",
                    title: "Product Created successfully! ",
                    text: `${name} has been created successfully!`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                fetchProducts();
                setLoading(false);
                onClose();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to create product",
                    text: `${response.data.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
            }
        } catch (error) {
            console.error('Network error:', error);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2">
                <div className='flex items-center justify-between'>
                    <h2 className="text-lg font-bold">Create a New Product</h2>
                    <button onClick={onClose} className="mt-4 bg-red-500 text-white rounded px-4 py-2">
                        <IoCloseSharp />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                        <input type="text" id="name" name="name" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            rows={2}
                            value={description} onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="category" className="block text-sm font-medium text-gray-700">Category</label>
                        <select
                        name="category"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                        required
                    >
                        <option value="">Select Category...</option>
                        <option value="tv">TV</option>
                        <option value="vod">Video</option>
                        <option value="event">Event</option>
                        <option value="shorts">Shorts</option>
                        <option value="series">Series</option>
                    </select>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="price" className="block text-sm font-medium text-gray-700">Price</label>
                        <input type="text" id="price" name="price" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            value={price} onChange={(e) => setPrice(e.target.value)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="thumbnail" className="block text-sm font-medium text-gray-700">Thumbnail</label>
                        <input type="file" id="thumbnail" name="thumbnail" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            onChange={(e) => setThumbnail(e.target.files[0])} />
                    </div>
                    <div className="flex justify-end">
                        <button type="submit" className="bg-primary text-white p-2 rounded">
                            {loading ? <ClipLoader size={20} color="#FFFFFF" /> : "Create"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}